/* eslint-disable eqeqeq */
import React, { useState, useRef } from 'react';
import ManageContainer from '../components/manageContainer';
import {
  ControlWrapper,
  StartButton,
  RestartButton,
  PlatRecord,
  // RecordStop,
  LocalRecord,
  PlatLive,
  TrackMode,
  LayoutMode,
  PlusTimeModal,
  TimeClock,
} from '../components/controlCard';
import ManageBar from '@/components/manageBar';
import './index.scss';

const Excellence = (props) => {
  const {
    match: {
      params: { id },
    },
  } = props;

  const propsRef = useRef();

  const [isHide] = useState(false);

  const [visible, setVisible] = useState(false);

  const [timeCurrent, setTimeCurrect] = useState(undefined);
  return (
    <ManageBar transparent={window.ext3bu} title="录播管控">
      <ManageContainer id={id}>
        {(props) => {
          const { detail, status, buttons, socket } = props;
          propsRef.current = props;
          return (
            <div className="interact">
              <div className={`display-wrapper background-image`}>
                <div className="elem-button-wrapper">
                  <div className="elem-time">
                    <TimeClock
                      value={status.duration}
                      endTime={status.endTime}
                      startTime={status.startTime}
                      onChange={setTimeCurrect}
                      onClick={() => {
                        if (status.conferenceStatus === '1') setVisible(true);
                      }}
                    ></TimeClock>
                  </div>
                  <StartButton
                    status={status.conferenceStatus || detail.conferenceStatus}
                    handleStart={() => propsRef.current.socket.startConference()}
                    handleEnd={() => propsRef.current.socket.endConference()}
                    withIcon={true}
                  ></StartButton>
                  {status.conferenceStatus == '1' ? (
                    <RestartButton id={id} socket={socket} />
                  ) : null}
                </div>
              </div>
              <ControlWrapper isHide={isHide} id={id} roomId={detail && detail.memberId}>
                <PlatRecord
                  time={status.recordTime}
                  status={buttons.platRecord}
                  handleClick={(params) => propsRef.current.socket.setPlatFormRecord(params)}
                ></PlatRecord>
                {/* <RecordStop
                  status={buttons.platRecord}
                  handleClick={(params) => propsRef.current.socket.setPlatFormRecord(params)}
                ></RecordStop> */}
                <LocalRecord
                  status={buttons.localRecord}
                  handleClick={(params) => propsRef.current.socket.setLocalRecord(params)}
                />
                <PlatLive
                  status={buttons.platLive}
                  handleClick={(params) => {
                    propsRef.current.socket.setPlatFormLive(params);
                    if (params.operation === 'stop') {
                      propsRef.current.socket.setPlatFormRecord(params);
                    }
                  }}
                ></PlatLive>
                <TrackMode
                  status={buttons.trackMode}
                  handleClick={(params) => propsRef.current.socket.setTrackMode(params)}
                ></TrackMode>
                <LayoutMode
                  status={buttons.layoutMode}
                  handleChange={(params) => propsRef.current.socket.setSplitScreen(params)}
                ></LayoutMode>
              </ControlWrapper>
              <PlusTimeModal
                currect={timeCurrent}
                startTime={status.startTime}
                endTime={status.endTime}
                visible={visible}
                handleClose={() => {
                  setVisible(false);
                }}
                handleOk={(minutes) => {
                  propsRef.current.socket.setOverTime({ id, minutes });
                  setVisible(false);
                }}
              ></PlusTimeModal>
            </div>
          );
        }}
      </ManageContainer>
    </ManageBar>
  );
};

export default Excellence;
